import Page from "./page-view";

export default Page;
